/**
 * Bundle Offer -- Tiered Pricing JS
 * 2 for Rs.1699 | 3 for Rs.1999 | +Rs.200 off prepaid
 * Eclat Maison | Dark Luxury Edition
 */

class BundleOffer {
  constructor(el) {
    this.el = el;

    // Config
    this.tier1Qty    = parseInt(el.dataset.tier1Qty, 10)        || 2;
    this.tier1Price  = parseInt(el.dataset.tier1Price, 10)      || 169900;
    this.tier2Qty    = parseInt(el.dataset.tier2Qty, 10)        || 3;
    this.tier2Price  = parseInt(el.dataset.tier2Price, 10)      || 199900;
    this.prepaidDisc = parseInt(el.dataset.prepaidDiscount, 10) || 20000;

    // State
    this.selected    = [];
    this._sparkled   = false; // fire sparkle once per full unlock

    this._initDOM();
    this._bindEvents();
    this._initSlider();
    this._render();
  }

  _initDOM() {
    this.cards     = [...this.el.querySelectorAll('.bo-card')];
    this.bar       = this.el.querySelector('.js-bo-bar');
    this.slots     = [...this.el.querySelectorAll('.js-bo-slot')];
    this.counter   = this.el.querySelector('.js-bo-counter');
    this.progress  = this.el.querySelector('.js-bo-progress');
    this.msgEl     = this.el.querySelector('.js-bo-msg');
    this.totalEl   = this.el.querySelector('.js-bo-total');
    this.origEl    = this.el.querySelector('.js-bo-original');
    this.prepaidEl = this.el.querySelector('.js-bo-prepaid');
    this.cta       = this.el.querySelector('.js-bo-checkout');
    this.canvas    = this.el.querySelector('.js-bo-sparkle');
    this.gridEl    = this.el.querySelector('.bo-grid');
    this.dots      = [...this.el.querySelectorAll('.bo-slider-dot')];
  }

  _bindEvents() {
    this.cards.forEach(card => {
      card.querySelector('.bo-btn-add').addEventListener('click', () => this._add(card));
      card.querySelector('.bo-qty-plus').addEventListener('click', () => this._add(card));
      card.querySelector('.bo-qty-minus').addEventListener('click', () => this._remove(card));
    });

    this.el.querySelector('.js-bo-slots').addEventListener('click', e => {
      const btn = e.target.closest('.bo-bar__slot-remove');
      if (!btn) return;
      const idx = parseInt(btn.dataset.index, 10);
      if (!isNaN(idx) && this.selected[idx]) this._removeByIndex(idx);
    });

    this.cta.addEventListener('click', () => this._checkout());
  }

  /* ── Mobile slider dot sync ── */
  _initSlider() {
    if (!this.gridEl || this.dots.length === 0) return;
    this.gridEl.addEventListener('scroll', () => {
      const cardWidth = this.gridEl.firstElementChild
        ? this.gridEl.firstElementChild.offsetWidth : 1;
      const idx = Math.round(this.gridEl.scrollLeft / cardWidth);
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }, { passive: true });
  }

  /* ── State ── */
  _add(cardEl) {
    if (this.selected.length >= this.tier2Qty) { this._shakeBar(); return; }
    this.selected.push({
      id:           cardEl.dataset.productId,
      variantId:    cardEl.dataset.variantId,
      price:        parseInt(cardEl.dataset.price, 10),
      comparePrice: parseInt(cardEl.dataset.comparePrice, 10) || 0,
      title:        cardEl.dataset.title,
      image:        cardEl.dataset.image,
      el:           cardEl
    });
    this._render();
  }

  _remove(cardEl) {
    const id  = cardEl.dataset.productId;
    const idx = [...this.selected].map(i => i.id).lastIndexOf(id);
    if (idx !== -1) this._removeByIndex(idx);
  }

  _removeByIndex(idx) {
    this.selected.splice(idx, 1);
    this._sparkled = false; // allow re-trigger
    this._render();
  }

  /* ── Render ── */
  _render() {
    this._renderCards();
    this._renderBar();
    this._renderProgress();
  }

  _renderCards() {
    const counts = {};
    this.selected.forEach(item => { counts[item.id] = (counts[item.id] || 0) + 1; });

    this.cards.forEach(card => {
      const id      = card.dataset.productId;
      const count   = counts[id] || 0;
      const btnAdd  = card.querySelector('.bo-btn-add');
      const qtyWrap = card.querySelector('.bo-qty-wrap');
      const qtyVal  = card.querySelector('.bo-qty-val');

      if (count > 0) {
        btnAdd.style.display = 'none';
        qtyWrap.classList.add('is-visible');
        qtyVal.textContent = count;
        card.classList.add('is-selected');
      } else {
        btnAdd.style.display = '';
        qtyWrap.classList.remove('is-visible');
        card.classList.remove('is-selected');
      }
    });
  }

  _renderBar() {
    const count = this.selected.length;

    // Show/hide bar
    this.bar.classList.toggle('is-visible', count > 0);

    // Counter
    this.counter.textContent = count + ' / ' + this.tier2Qty + ' selected';

    // Slots
    this.slots.forEach((slot, i) => {
      if (i < count) {
        const item = this.selected[i];
        slot.classList.add('is-filled');
        slot.innerHTML =
          '<img src="' + item.image + '" alt="' + item.title + '" class="bo-bar__slot-img">' +
          '<button type="button" class="bo-bar__slot-remove" data-index="' + i + '" aria-label="Remove">&#x2715;</button>';
      } else {
        slot.classList.remove('is-filled');
        slot.innerHTML = '<span class="bo-bar__slot-num">' + (i + 1) + '</span>';
      }
    });

    // Pricing
    const rawTotal  = this.selected.reduce((s, it) => s + it.price, 0);
    const origTotal = this.selected.reduce((s, it) => s + (it.comparePrice > it.price ? it.comparePrice : it.price), 0);

    let bundlePrice = null;
    let canCheckout = false;

    if (count === this.tier2Qty) {
      bundlePrice = this.tier2Price; canCheckout = true;
    } else if (count === this.tier1Qty) {
      bundlePrice = this.tier1Price; canCheckout = true;
    }

    if (bundlePrice !== null) {
      this.origEl.textContent = this._money(origTotal > bundlePrice ? origTotal : rawTotal);
      this.origEl.classList.add('is-visible');
      this.totalEl.textContent = this._money(bundlePrice);
      this.prepaidEl.textContent = 'Pay ' + this._money(bundlePrice - this.prepaidDisc) + ' with prepaid';
    } else {
      this.origEl.classList.remove('is-visible');
      this.totalEl.textContent = rawTotal > 0 ? this._money(rawTotal) : 'Rs.0';
      this.prepaidEl.textContent = '';
    }

    this.cta.disabled = !canCheckout;
  }

  _renderProgress() {
    const count = this.selected.length;
    let pct = 0;

    if (count === 0) {
      pct = 0;
      this.msgEl.textContent = 'Select ' + this.tier1Qty + ' perfumes to unlock bundle pricing';
      this.msgEl.classList.remove('is-unlocked');
    } else if (count < this.tier1Qty) {
      pct = (count / this.tier2Qty) * 100;
      this.msgEl.textContent = (this.tier1Qty - count) + ' more to unlock \u2014 Rs.1,699 for 2';
      this.msgEl.classList.remove('is-unlocked');
    } else if (count === this.tier1Qty) {
      pct = (count / this.tier2Qty) * 100;
      this.msgEl.textContent = 'Rs.1,699 unlocked \u2714  Add 1 more for the best deal';
      this.msgEl.classList.add('is-unlocked');
    } else if (count >= this.tier2Qty) {
      pct = 100;
      this.msgEl.textContent = 'Best bundle unlocked \u2014 3 for Rs.1,999!';
      this.msgEl.classList.add('is-unlocked');
      // Fire sparkle once
      if (!this._sparkled) { this._sparkled = true; this._launchSparkle(); }
    }

    this.progress.style.width = Math.min(pct, 100) + '%';
  }

  /* ── Sparkle ── */
  _launchSparkle() {
    const canvas = this.canvas;
    if (!canvas) return;

    const W = canvas.width  = window.innerWidth;
    const H = canvas.height = window.innerHeight;
    const ctx = canvas.getContext('2d');
    canvas.classList.add('is-active');

    const GOLD   = ['#c9a96e','#e2c99a','#f5dfa0','#fff8e7','#a8884d'];
    const N      = 90;
    const particles = [];

    for (let i = 0; i < N; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = 3 + Math.random() * 5;
      particles.push({
        x:  W * 0.5 + (Math.random() - 0.5) * 200,
        y:  H * 0.55,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - (3 + Math.random() * 4),
        r:  2 + Math.random() * 3,
        color: GOLD[Math.floor(Math.random() * GOLD.length)],
        alpha: 1,
        rot:   Math.random() * Math.PI * 2,
        rotV:  (Math.random() - 0.5) * 0.25,
        type:  Math.random() > 0.5 ? 'circle' : 'star'
      });
    }

    let frame = 0;
    const MAX = 90;

    const tick = () => {
      ctx.clearRect(0, 0, W, H);
      frame++;

      particles.forEach(p => {
        p.x  += p.vx;
        p.y  += p.vy;
        p.vy += 0.18;        // gravity
        p.vx *= 0.98;
        p.alpha = Math.max(0, 1 - frame / MAX);
        p.rot  += p.rotV;

        ctx.save();
        ctx.globalAlpha = p.alpha;
        ctx.fillStyle   = p.color;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);

        if (p.type === 'star') {
          this._drawStar(ctx, 0, 0, p.r * 2.5, 4, 0.4);
        } else {
          ctx.beginPath();
          ctx.ellipse(0, 0, p.r, p.r * 0.55, 0, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      });

      if (frame < MAX) {
        requestAnimationFrame(tick);
      } else {
        canvas.classList.remove('is-active');
        ctx.clearRect(0, 0, W, H);
      }
    };

    requestAnimationFrame(tick);
  }

  _drawStar(ctx, cx, cy, outerR, points, innerRatio) {
    ctx.beginPath();
    for (let i = 0; i < points * 2; i++) {
      const angle = (i * Math.PI) / points - Math.PI / 2;
      const r     = i % 2 === 0 ? outerR : outerR * innerRatio;
      i === 0
        ? ctx.moveTo(cx + Math.cos(angle) * r, cy + Math.sin(angle) * r)
        : ctx.lineTo(cx + Math.cos(angle) * r, cy + Math.sin(angle) * r);
    }
    ctx.closePath();
    ctx.fill();
  }

  _shakeBar() {
    this.bar.style.animation = 'none';
    this.bar.offsetHeight; // reflow
    this.bar.style.animation = 'bo-shake .4s ease';
  }

  /* ── Cart ── */
  async _checkout() {
    const count = this.selected.length;
    if (count !== this.tier1Qty && count !== this.tier2Qty) return;

    this.cta.disabled = true;
    this.cta.classList.add('is-loading');

    const map = {};
    this.selected.forEach(item => {
      if (map[item.variantId]) {
        map[item.variantId].quantity += 1;
      } else {
        map[item.variantId] = {
          id: item.variantId,
          quantity: 1,
          properties: { _bundle_tier: count === this.tier2Qty ? 'tier2_3for1999' : 'tier1_2for1699' }
        };
      }
    });

    try {
      const sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });
      const sectionsToUpdate = sectionIds.length > 0 ? sectionIds.join(',') : undefined;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: Object.values(map), sections: sectionsToUpdate })
      });
      if (!res.ok) throw new Error('Cart add failed');
      const data = await res.json();

      if (data.sections) {
        Object.entries(data.sections).forEach(([sectionId, html]) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const target = document.getElementById(sectionId);
          const source = doc.querySelector(`#${sectionId}`);
          if (target && source) target.innerHTML = source.innerHTML;
        });
      }

      // Refresh cart state & notify theme
      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

      // Notify other components like the cart drawer
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          sourceId: 'bundle-offer',
          data: {
            itemCount: Object.values(map).length,
            sections: data.sections || {},
          },
        },
      }));

      // Open cart drawer or go to /cart
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = '/cart';
      }

      // Reset bundle state
      setTimeout(() => {
        this.selected  = [];
        this._sparkled = false;
        this._render();
      }, 800);

    } catch (err) {
      console.error('[BundleOffer]', err);
      alert('Could not add to cart. Please try again.');
    } finally {
      this.cta.disabled = false;
      this.cta.classList.remove('is-loading');
    }
  }

  _money(cents) {
    return 'Rs.' + (cents / 100).toLocaleString('en-IN');
  }
}

// Init
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.bo-section').forEach(el => new BundleOffer(el));
});
